// extracted by mini-css-extract-plugin
export var about = "index-module--about--df686";
export var aboutContainer = "index-module--about-container--d8b50";
export var blog = "index-module--blog--19716";
export var blurb = "index-module--blurb--a8984";
export var bulletDivider = "index-module--bullet-divider--e355c";
export var centerText = "index-module--center-text--aeed3";
export var contact = "index-module--contact--76169";
export var logo = "index-module--logo--eb455";
export var moreBounce = "index-module--more-bounce--9fa88";
export var moreLink = "index-module--more-link--04f1f";
export var portrait = "index-module--portrait--126aa";
export var svgIcon = "index-module--svg-icon--4cf83";